import React, { memo } from 'react';
import { css } from 'emotion';

const style = css`
  width: 1px;
  background-color: #dfe2ec;
  align-self: stretch;
  margin: 0 12px;
`;

const Divider = () => <div className={style} />;

export default memo(Divider);
